"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeContext = void 0;
var react_1 = require("react");
var themeState_1 = require("./state/themeState");
exports.ThemeContext = (0, react_1.createContext)((0, themeState_1.initialState)());
exports.ThemeContext.displayName = 'ThemeContext';
//# sourceMappingURL=ThemeContext.js.map